import { render, staticRenderFns } from "./StockAdj_Result_Details.vue?vue&type=template&id=0528a090"
import script from "./StockAdj_Result_Details.vue?vue&type=script&lang=js"
export * from "./StockAdj_Result_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports